if (!customElements.get('nopa-testimonials')) {
  class NopaTestimonials extends HTMLElement {
    connectedCallback() {
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.i = 0;
      this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(-1));
      this.querySelector('[data-next]')?.addEventListener('click', () => this.go(1));
      this.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') this.go(-1);
        if (e.key === 'ArrowRight') this.go(1);
      });
      if (this.dataset.autoplay === 'true') {
        setInterval(() => this.go(1), parseInt(this.dataset.interval || '6000', 10));
      }
    }
    go(dir) {
      if (!this.slides.length) return;
      this.slides[this.i].classList.remove('is-active');
      this.i = (this.i + dir + this.slides.length) % this.slides.length;
      this.slides[this.i].classList.add('is-active');
    }
  }
  customElements.define('nopa-testimonials', NopaTestimonials);
}
